<template>
  <BaseSection :step="step">

    <template #title>Ad Hoc Charges</template>

    <template #content>

      <template v-if="isPreLiveProduct">
        <div>Ad Hoc Charges not supported for Pre Live product</div>
      </template>

      <template v-else-if="getAdhocCharges.length">
        <template v-for="(charge,index) in getAdhocCharges">
          <AddonsDisplay :addon="charge" :key="index" :disableCheck="true" />
        </template>
      </template>

      <template v-else>
        <div>There are no required charges for the selected tariff.</div>
      </template>

      <v-row>
        <v-col>
          <v-btn color="primary" outlined class="my-0 mr-2" @click="submitBack">Back</v-btn>
          <v-btn color="primary" class="my-0" @click="submitContinue">Continue</v-btn>
        </v-col>
      </v-row>

    </template>

  </BaseSection>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/BaseSection';
  import AddonsDisplay from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/all/AddonsDisplay';
  
  export default {
    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: { BaseSection,AddonsDisplay },

    computed: {
      ...mapGetters('changeTariff',['getAdhocCharges','isPreLiveProduct']),
    },

    methods: {
      ...mapMutations('changeTariff',['set_stepNext','set_stepPrev']),

      submitContinue(){
        this.set_stepNext();
      },

      submitBack(){
        this.set_stepPrev();
      },
    },
  }
</script>

<style lang="scss" scoped></style>
